import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export function EmptyState({ icon: Icon, title, description, action, actionLabel, testId }) {
  return (
    <Card className="border-dashed" data-testid={testId || 'empty-state'}>
      <CardContent className="p-10 text-center">
        {Icon && <div className="mx-auto h-12 w-12 rounded-2xl bg-accent flex items-center justify-center text-accent-foreground"><Icon className="h-6 w-6" /></div>}
        <div className="mt-4 font-heading text-lg">{title}</div>
        {description && <div className="text-sm text-muted-foreground mt-1">{description}</div>}
        {action && actionLabel && (
          <div className="mt-4"><Button onClick={action}>{actionLabel}</Button></div>
        )}
      </CardContent>
    </Card>
  );
}

export default EmptyState;
